import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './goal-progress-history-loading.style';

export const GoalProgressHistoryLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
